var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4958 14.996C16.7448 15.245 16.783 15.6401 16.5536 15.9073C15.4532 17.1886 13.8213 18.0001 12 18.0001C10.1786 18.0001 8.54675 17.1886 7.44636 15.9073C7.21689 15.6401 7.25509 15.245 7.50413 14.996C7.83689 14.6632 8.39391 14.7331 8.71568 15.0764C9.53675 15.9527 10.7044 16.5001 12 16.5001C13.2955 16.5001 14.4632 15.9527 15.2842 15.0764C15.606 14.7331 16.163 14.6632 16.4958 14.996Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.75C9.75 10.5784 9.07843 11.25 8.25 11.25C7.42157 11.25 6.75 10.5784 6.75 9.75C6.75 8.92157 7.42157 8.25 8.25 8.25C9.07843 8.25 9.75 8.92157 9.75 9.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.25C16.5784 11.25 17.25 10.5784 17.25 9.75C17.25 8.92157 16.5784 8.25 15.75 8.25C14.9216 8.25 14.25 8.92157 14.25 9.75C14.25 10.5784 14.9216 11.25 15.75 11.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSmile);
export default __webpack_public_path__ + "static/media/face-smile.f5b0373b9a91193eaf5fd3fbea016140.svg";
export { ForwardRef as ReactComponent };